import TableRoot from './components/table-root.jsx'
import TableContent from './components/table-content.jsx'
import PaginationComponent from './components/pagination/index.jsx'
import TableToolbar from './components/toolbar/index.jsx'

const TableComponent = {
  Root: TableRoot,
  Content: TableContent,
  Pagination: PaginationComponent,
  Toolbar: TableToolbar
}

export default TableComponent
